const FALLBACK_MESSAGE =
  'Entre em contato com seu banco provedor ou tente novamente mais tarde.';

const FIELD_LABELS: Record<string, string> = {
  card_number: 'Número do cartão',
  holder_name: 'Nome do titular',
  expiration_month: 'Mês de validade',
  expiration_year: 'Ano de validade',
  security_code: 'Código de segurança',
  taxpayer_id: 'CPF/CNPJ',
  first_name: 'Nome',
  last_name: 'Sobrenome',
  email: 'Email',
  phone_number: 'Telefone',
  address: 'Endereço',
  'address.line1': 'Endereço',
  'address.city': 'Cidade',
  'address.state': 'Estado',
  'address.postal_code': 'CEP',
  city: 'Cidade',
  state: 'Estado',
  postal_code: 'CEP',
  card_id: 'Cartão',
};

const labelFor = (field: string) => FIELD_LABELS[field] || field;

const pickFirstString = (value: any): string | null => {
  if (typeof value === 'string' && value.trim()) return value.trim();
  if (Array.isArray(value)) {
    for (const item of value) {
      const found = pickFirstString(item);
      if (found) return found;
    }
  }
  if (value && typeof value === 'object') {
    for (const v of Object.values(value)) {
      const found = pickFirstString(v);
      if (found) return found;
    }
  }
  return null;
};

const formatFieldErrors = (errors: Record<string, any>): string | null => {
  const lines: string[] = [];
  for (const field of Object.keys(errors)) {
    const value = errors[field];
    const msg = pickFirstString(value);
    if (msg) lines.push(`${labelFor(field)}: ${msg}`);
  }
  return lines.length ? lines.join('\n') : null;
};

export const extractErrorMessage = (
  error: any,
  fallback: string = FALLBACK_MESSAGE,
): string => {
  if (!error) return fallback;

  const data = error?.response?.data ?? error?.data ?? error;

  if (data && typeof data === 'object') {
    if (data.error && typeof data.error === 'object') {
      const display =
        data.error.message_display ||
        data.error.message ||
        pickFirstString(data.error);
      if (display) return display;
    }

    if (data.errors) {
      if (typeof data.errors === 'string' && data.errors.trim()) {
        return data.errors.trim();
      }
      if (Array.isArray(data.errors)) {
        const first = pickFirstString(data.errors);
        if (first) return first;
      } else if (typeof data.errors === 'object') {
        const formatted = formatFieldErrors(data.errors);
        if (formatted) return formatted;
      }
    }

    if (typeof data.message === 'string' && data.message.trim()) {
      const msg = data.message.trim();
      if (msg.toLowerCase() !== 'server error') return msg;
    }
  }

  const status = error?.response?.status;
  if (status === 0 || error?.code === 'ECONNABORTED' || error?.message === 'Network Error') {
    return 'Sem conexão com o servidor. Verifique sua internet e tente novamente.';
  }

  return fallback;
};

export default extractErrorMessage;
